SET_MESSAGE_BOX_TYPE